import React from 'react'
import T from 'prop-types'
import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import ConfirmationDialog from 'components/atoms/ConfirmationDialog'

export default function AssignmentConfirmationDialog({
  open,
  handleClose,
  handleSubmit,
}) {
  const { t } = useTranslation()

  return (
    <ConfirmationDialog
      title={t('assignment.confirmationDialog.title')}
      contentComponent={Box}
      content={
        <>
          <Typography variant="body2">
            {t('assignment.confirmationDialog.content')}
          </Typography>
        </>
      }
      open={open}
      handleClose={handleClose}
      handleSubmit={handleSubmit}
    />
  )
}

AssignmentConfirmationDialog.propTypes = {
  open: T.bool,
  handleClose: T.func,
  handleSubmit: T.func,
}
